import interact from 'interactjs';
import { DEFAULTS } from 'lib/constants';

class DrawingUI {
  constructor() {
    this.selectedDrawingIds = new Set();
    this.resetDragData();

    this.defaults = {
      color: DEFAULTS.DRAWING_COLOR,
      opacity: DEFAULTS.DRAWING_OPACITY,
      strokeWidth: DEFAULTS.DRAWING_STROKE_WIDTH,
    };
  }

  setCanvas(canvas) {
    this.canvas = canvas;
  }

  getDefaults() {
    return this.defaults;
  }

  setDefaults(newDefaults) {
    Object.assign(this.defaults, newDefaults);
  }

  resetDragData() {
    this.prevDrawingPositions = {};
    this.draggingDrawings = [];
  }

  getDashArray(type, width) {
    if (type == 'dotted') {
      if (width == 'xs') {
        return '4px 6px';
      } else if (width == 's') {
        return '8px 12px';
      } else if (width == 'm') {
        return '12px 18px';
      } else if (width == 'l') {
        return '16px 24px';
      } else if (width == 'xl') {
        return '24px 32px';
      } else {
        return '8px 8px';
      }
    } else if (type == 'dashed') {
      if (width == 'xs') {
        return '4px 3px';
      } else if (width == 's') {
        return '9px 6px';
      } else if (width == 'm') {
        return '12px 9px';
      } else if (width == 'l') {
        return '18px 12px';
      } else if (width == 'xl') {
        return '24px 16px';
      } else {
        return '9px 6px';
      }
    } else if (type == 'solid') {
      return 0;
    }
  }

  createDrawing({ path, top, left, bottom, right, x, y, height, width, color, strokeWidth, opacity }) {
    const { canvas } = this;
    const drawing = canvas.store.addDrawing({
      path,
      top,
      left,
      bottom,
      right,
      x,
      y,
      height,
      width,
      color,
      strokeWidth,
      // strokeType,
      opacity,
    });

    // if (operationMessages) {
    //   /* create region as part of some greater batch process, like copy/paste */
    //   const message = canvas.operation.messages.addRegion({
    //     regionUUID: region.id,
    //     title: region.title,
    //     color: region.color,
    //     shape: region.shape,
    //     top: region.top,
    //     left: region.left,
    //     bottom: region.bottom,
    //     right: region.right,
    //     onSuccess: console.log,
    //     onFailure: console.log,
    //   });
    //   operationMessages.push(message);
    // } else {


    canvas.operation.addDrawing({
      uuid: drawing.id,
      path: drawing.path,
      top: drawing.top,
      left: drawing.left,
      bottom: drawing.bottom,
      right: drawing.right,
      x: drawing.x,
      y: drawing.y,
      height: drawing.height,
      width: drawing.width,
      color: drawing.color,
      strokeWidth: drawing.strokeWidth,
      strokeType: drawing.strokeType,
      opacity: drawing.opacity,
      onSuccess: console.log,
      onFailure: console.log,
    });
    canvas.drawingsTag.update();
      // canvas.drawingTags[drawing.id].setSelected();
    // }

    // canvas.appFooterTag.update();
    return drawing;
  }

  deleteDrawing({ id }) {
    const { canvas } = this;
    const { store, operation } = canvas;
    const drawing = store.getDrawing(id);

    operation.deleteDrawing(Object.assign({
      uuid: id,
      onSuccess: console.log,
      onFailure: console.warn,
    }, drawing));

    store.deleteDrawing({ id });
    delete canvas.drawingTags[id];
    canvas.drawingsTag.update();

    this.removeDrawingFromSelection(id);
    canvas.multiSelectionIndicatorBox.update();
  }

  saveDrawingProperty({id, property, newValue, prevValue}) {
    operation.updateDrawingDisplayProperties({
      uuid: id,
      displayProperties: { [property]: newValue },
      prevDisplayProperties: { [property]: prevValue },
      onFailure: (err) => {
        console.log(`set drawing ${property} failure: ${err}`);
      }
    });
  }

  getSelectedDrawingIds() {
    return this.selectedDrawingIds;
  }

  getSelectedDrawings() {
    return this.getSelectedDrawingIdsArray()
      .map(id => this.canvas.store.getDrawing(id));
  }

  getSelectedDrawingIdsArray() {
    return Array.from(this.selectedDrawingIds);
  }

  deleteSelectedDrawings({ operationMessages }) {
    if (!this.selectedDrawingIds || !this.selectedDrawingIds.size) return;
    this.deleteDrawings({ ids: this.selectedDrawingIds, operationMessages });
  }

  deleteDrawings({ ids,operationMessages }) {
    const { canvas } = this;
    const { store, operation } = canvas;
    const messages = [];

    for (const id of ids) {
      const drawing = store.getDrawing(id);
      const message = operation.messages.deleteDrawing(Object.assign({ uuid: id }, drawing));
      messages.push(message);
      store.deleteDrawing({ id });
      this.removeDrawingFromSelection(id);
      delete canvas.drawingTags[id];
    }

    canvas.drawingsTag.update();

    if (operationMessages) {
      for (const message of messages) {
        operationMessages.push(message);
      }
    } else {
      operation.batchOperation({
        messages,
        onFailure: console.warn,
      });
    }

    canvas.multiSelectionIndicatorBox.update();
  }

  selectDrawing(drawingId, shiftKey) {
    if (!shiftKey) {
      this.clearSelectedDrawings();
    }
    this.addDrawingToSelection(drawingId);
  }

  selectDrawings(drawingIds) {
    for (const drawingId of drawingIds) {
      this.addDrawingToSelection(drawingId);
    }
  }

  getDrawingTag(id) {
    return this.canvas.drawingTags[id];
  }

  addDrawingToSelection(drawingId) {
    const { selectedDrawingIds } = this;
    const drawingTag = this.getDrawingTag(drawingId);

    if (!selectedDrawingIds.has(drawingId)) {
      selectedDrawingIds.add(drawingId);
    }

    if (drawingTag) {
      drawingTag.setSelected();
    }
  }

  removeDrawingFromSelection(drawingId) {
    const { selectedDrawingIds } = this;

    if (selectedDrawingIds.has(drawingId)) {
      selectedDrawingIds.delete(drawingId);

      if (this.draggingDrawings) {
        this.draggingDrawings = this.draggingDrawings.filter( r => r.id !== drawingId );
      }

      const drawingTag = this.getDrawingTag(drawingId);

      if (drawingTag) {
        drawingTag.deSelect();
      }
    }
  }

  clearSelectedDrawings() {
    const oldSelection = this.selectedDrawingIds;

    if (this.selectedDrawingIds.size) {
      for (const id of oldSelection) {
        const drawingTag = this.getDrawingTag(id);

        if (drawingTag) {
          drawingTag.deSelect();
        }
      }

      this.resetDragData();
      this.selectedDrawingIds.clear();
    }

    this.canvas.bulkActionsMenuTag.update();
    this.canvas.multiSelectionIndicatorBox.update();

    return oldSelection;
  }

  getBulkDrawingColor(ids) {
    const colors = [];
    const seen = {};
    for (const id of ids) {
      const drawing = this.canvas.store.getDrawing(id);
      if (drawing && !seen[drawing.color]) {
        colors.push(drawing.color);
        seen[drawing.color] = true;
      }
    }
    if (colors.length == 1) {
      return colors[0];
    }
    return null;
  }

  setupDragging() {
    /* can move and resize; can't create a selection box over the drawing */
    if (this.dragger) this.dragger.off();
    this.dragger = interact('.drawing')
      .styleCursor(false)
      .actionChecker((pointer, event, action, interactable, element, interaction) => {
        // if dragging isn't enabled, then the user can use the selection area on a drawing
        if (action.name == 'drag' && element.getAttribute('data-move-enabled') != 'true') {
          action.name = null;
        }

        return action;
      })
      .draggable({
        max: 3,
        maxPerElement: 3,
        onstart: this.onMoveStart.bind(this),
        onmove: this.onMove.bind(this),
        onend: this.onMoveEnd.bind(this),
      })
      .resizable({
        edges: {
          top: '.region-resize-handle--top',
          left: '.region-resize-handle--left',
          bottom: '.region-resize-handle--bottom',
          right: '.region-resize-handle--right',
        },
        restrictSize: {
          min: {
            height: 150,
            width: 150,
          },
        },
        onstart: this.onResizeStart.bind(this),
        onmove: this.onResize.bind(this),
        onend: this.onResizeEnd.bind(this),
      });
  };

  onResizeMoveStart(e) {
    const drawingID = e.target.getAttribute('data-drawing-id');
    const dragDrawing = canvas.drawingTags[drawingID];
    this.dragDrawing = dragDrawing;
    this.dragDrawing.onResizeMoveStart(e);
  };

  onMoveStart(e) {
    if (!e.interaction.downEvent.target.classList.contains('drag-handle')) {
      return;
    }
    const drawingId = e.target.getAttribute('data-drawing-id');
    const dragDrawing = canvas.drawingTags[drawingId];
    const { isMac } = canvas;
    this.dragDrawing = dragDrawing;

    if ((isMac && e.metaKey) || (!isMac && e.ctrlKey)) {
      if (!canvas.inTheMiddleOfMetaDrag) {
        canvas.inTheMiddleOfMetaDrag = true;
        dragDrawing.toggleSelected(e);
      }
    }

    this.dragDrawing.onMoveStart(e);
  }

  onMove(e) {
    e.stopImmediatePropagation();
    if (!e.interaction.downEvent.target.classList.contains('drag-handle')) {
      return;
    }
    this.dragDrawing.onMove(e);
  }

  onMoveEnd(e) {
    if (!this.dragDrawing) return;
    this.dragDrawing.onMoveEnd(e);
    this.dragDrawing = null;
  }

  onResizeStart(e, { moving, drawingId } = {}) {
    const drawingID = e.target.getAttribute('data-drawing-id');
    const dragDrawing = canvas.drawingTags[drawingID];

    this.moving = moving || {
      top: e.interaction.downEvent.target.className.includes('top'),
      left: e.interaction.downEvent.target.className.includes('left'),
      bottom: e.interaction.downEvent.target.className.includes('bottom'),
      right: e.interaction.downEvent.target.className.includes('right'),
    };

    this.dragDrawing = dragDrawing;
    dragDrawing && this.dragDrawing.onResizeMoveStart(e);
  }

  onResize(e) {
    e.stopImmediatePropagation();
    this.dragDrawing.onResize(e);
  }

  onResizeEnd(e) {
    this.dragDrawing.onResizeMoveEnd(e);
    this.dragDrawing = null;
    this.moving = {};
  }

  applyResize({ drawing, rect: {top, left, bottom, right}, aspectRatio}) {
    const { moving } = this;
    const height = Math.abs(right - left) / aspectRatio;
    if (!moving) return;

    if (moving.top) {
      drawing.top = drawing.bottom - height;
    }

    if (moving.bottom) {
      drawing.bottom = drawing.top + height;
    }

    if (moving.right) drawing.right = right;
    if (moving.left) drawing.left = left;
  }

  setPrevDrawingPosition(drawing) {
    const { top, left, right, bottom, id } = drawing;
    this.prevDrawingPositions[id] = { top, left, right, bottom };
  }

  prepareSelectedDrawingsForMove() {
    if (!this.selectedDrawingIds || !this.selectedDrawingIds.size) return;

    const drawings = [];

    for (const drawingId of this.selectedDrawingIds) {
      const drawing = this.canvas.store.getDrawing(drawingId);
      drawings.push(drawing);

      for (const drawing of drawings) {
        this.setPrevDrawingPosition(drawing);
      }
    }

    this.addDraggableDrawings(drawings);
  }

  addDraggableDrawings(drawings) {
    for (const drawing of drawings) {
      if (this.draggingDrawings.find(({ id }) => id == drawing.id)) continue;
      this.draggingDrawings.push(drawing);
    }
  }

  applyMoveToDrawings({ dx,dy, excludeDrawings }) {
    const { draggingDrawings } = this;

    if (draggingDrawings && draggingDrawings.length) {
      for (const drawing of draggingDrawings.filter(({ id }) => !excludeDrawings || !excludeDrawings.includes(id))) {
        this.applyMove({ dx, dy, draggingDrawing: drawing });
        const drawingTag = this.getDrawingTag(drawing.id);
        if (drawingTag) {
          drawingTag.refreshPosition();
        }
      }
    }
  }

  applyDrawingPositionOperations({ operationMessages }) {
    if (!this.draggingDrawings || !this.draggingDrawings.length) return;

    for (const drawing of this.draggingDrawings) {
      const message = this.getDrawingPositionOperationMessage(drawing);
      operationMessages.push(message);
    }
  }

  getDrawingPositionOperationMessage(drawing) {
    const { id, top, left, right, bottom } = drawing;

    return this.canvas.operation.messages.updateDrawingDisplayProperties({
      uuid: id,
      prevDisplayProperties: this.prevDrawingPositions[id],
      displayProperties: {
        top,
        left,
        right,
        bottom,
      },
    });
  }

  applyMove({ draggingDrawing, dx, dy }) {
    draggingDrawing.left += dx;
    draggingDrawing.right += dx;
    draggingDrawing.top += dy;
    draggingDrawing.bottom += dy;
  }
}

const drawingUI = new DrawingUI;
window.drawingUI = drawingUI;
export { DrawingUI, drawingUI };



// WEBPACK FOOTER //
// ./starling/src/lib/drawing-ui.js